import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { E as h, S as u } from "./icons.types-0722eef5.js";
function _({ title: o, titleId: t, size: i, width: s, height: c, extended: e = !1, ...a }) {
  const l = e ? h : u, d = i ? l[i] : s || l[e ? "s" : "l"], f = i ? l[i] : c || l[e ? "s" : "l"];
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 53",
      width: d,
      height: f,
      "aria-labelledby": t,
      ...a,
      children: [
        o ? /* @__PURE__ */ r("title", { id: t, children: o }) : null,
        /* @__PURE__ */ r(
          "g",
          {
            filter: "url(#Pin_dot_svg__a)",
            opacity: 0.4,
            children: /* @__PURE__ */ r(
              "ellipse",
              {
                cx: 16,
                cy: 47,
                fill: "#6B7786",
                rx: 6,
                ry: 2
              }
            )
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            stroke: "currentColor",
            d: "m16 44 .426.262.002-.004.006-.01.025-.04.096-.155.364-.593 1.305-2.12c1.081-1.758 2.529-4.109 3.993-6.484 2.933-4.76 5.914-9.587 6.16-9.95l.006-.01c.928-1.43 2.117-4.024 2.117-7.146C30.5 9.84 24.031 3.5 16 3.5 7.969 3.5 1.5 9.84 1.5 17.75c0 3.122 1.19 5.716 2.117 7.147l.006.009c.246.363 3.227 5.19 6.16 9.95l3.994 6.484 1.304 2.12.364.593.096.156.025.04.006.01.002.002L16 44Zm0 0 .426.262-.426.692-.426-.692L16 44Z"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            d: "M22 18c0 3.36-2.64 6-6 6s-6-2.64-6-6 2.64-6 6-6 6 2.64 6 6Z"
          }
        ),
        /* @__PURE__ */ r("defs", { children: /* @__PURE__ */ n(
          "filter",
          {
            id: "Pin_dot_svg__a",
            width: 20,
            height: 12,
            x: 6,
            y: 41,
            colorInterpolationFilters: "sRGB",
            filterUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ r(
                "feFlood",
                {
                  floodOpacity: 0,
                  result: "BackgroundImageFix"
                }
              ),
              /* @__PURE__ */ r(
                "feBlend",
                {
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              ),
              /* @__PURE__ */ r(
                "feGaussianBlur",
                {
                  result: "effect1_foregroundBlur_34905_20530",
                  stdDeviation: 2
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}
export {
  _ as PinDot
};
